import MultiSelectConfigOptionGroup from "./MultiSelectConfigOptionGroup";

export default class MultiSelectConfig {
    public options: MultiSelectConfigOptionGroup[] = [];

    public singleSelect?: boolean;
}